var map = {
	"./blue/ambulance.png": 26256,
	"./blue/bus.png": 46428,
	"./blue/dumper.png": 23555,
	"./blue/police.png": 19686,
	"./blue/school bus.png": 54278,
	"./blue/tanker.png": 88929,
	"./blue/taxi.png": 98012,
	"./blue/truck.png": 28703,
	"./default/ambulance.png": 92467,
	"./default/bus.png": 58491,
	"./default/dumper.png": 42922,
	"./default/police.png": 88983,
	"./default/school bus.png": 24059,
	"./default/tanker.png": 47824,
	"./default/taxi.png": 11005,
	"./default/truck.png": 1168,
	"./green/ambulance.png": 85401,
	"./green/bus.png": 781,
	"./green/dumper.png": 93252,
	"./green/police.png": 60997,
	"./green/school bus.png": 89137,
	"./green/tanker.png": 12754,
	"./green/taxi.png": 75667,
	"./green/truck.png": 9294,
	"./grey/ambulance.png": 76889,
	"./grey/bus.png": 87885,
	"./grey/dumper.png": 51556,
	"./grey/police.png": 85221,
	"./grey/school bus.png": 54545,
	"./grey/tanker.png": 25682,
	"./grey/taxi.png": 88595,
	"./grey/truck.png": 55278,
	"./icons/CAR.png": 12874,
	"./icons/logo_truck.png": 97935,
	"./icons/stqc_logo.png": 52153,
	"./orange/ambulance.png": 72574,
	"./orange/bus.png": 44990,
	"./orange/dumper.png": 16053,
	"./orange/police.png": 62500,
	"./orange/school bus.png": 4172,
	"./orange/tanker.png": 89475,
	"./orange/taxi.png": 65354,
	"./orange/truck.png": 28101,
	"./red/ambulance.png": 701,
	"./red/bus.png": 12705,
	"./red/dumper.png": 15544,
	"./red/police.png": 33793,
	"./red/school bus.png": 20901,
	"./red/tanker.png": 79326,
	"./red/taxi.png": 5663,
	"./red/truck.png": 69370,
	"./users/Untitled-removebg-preview.png": 62556
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3013;